<div class="text-center py-3 h2 loading" *ngIf="show">
    <i class="fa fa-2x fa-circle-o-notch fa-spin my-3"></i>
    <div class="text-uppercase">{{message}}...</div>
</div>